import React, { FC, useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import NavWrapper from '../components/wrappers/NavWrapper';
import DoorOpener from '../pages/dooropener';
import { userContext } from '../utils/userContext';

const DoorOpenerRouter: FC = () => {
    let match = useRouteMatch();
    const { hasModule } = useContext(userContext);

    return (
        <NavWrapper pageName="SMS døråbner">
            {!hasModule(match.url) ? <Route component={() => <div>Du har ikke adgang til SMS Dør åbner</div>}/> :
                <Switch>
                    <Route exact path={match.url} component={DoorOpener}/>
                    <Route> <div>Siden bliv ikke fundet</div></Route>
                </Switch>
            }
        </NavWrapper>
    )
}

export default DoorOpenerRouter;
